import React, { Component } from "react";
import "../auth/auth.css";
import "../app/base-style.css";
import {
  Typography,
  Grid,
  Card,
  Button,
  InputAdornment,
  Hidden,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import {
  OutlinedTextFiled,
  MobileOutlinedTextFiled,
  ConnectionOutlinedTextFiled,
} from "../auth/auth-style";
import ReactCountryFlag from "react-country-flag";
import { AboutAccount } from "./about-your-account";
import HelpIcon from "@material-ui/icons/Help";
import CloseIcon from "@material-ui/icons/Close";
import { usageService } from "../../services/index";
import { Skeleton, Alert } from "@material-ui/lab";
import { store } from "../../helpers";
import { appActions } from "../../actions/app.actions";
import { connect } from "react-redux";
import { history } from "../../helpers/index";
import { routePaths } from "../config/route-paths";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import flags from "react-phone-number-input/flags";
import ConnectionFinder from "./quick-pay-connection-finder"

let labels = "";
let mobileLength = "";
let country_Calling_Code = "";
let country_Code = "";
let email_regex = "";
let billId_length = "";
store.subscribe(() => {
  if (store.getState().labels.data) {
    labels = store.getState().labels.data.getLabels.USER_MANAGEMENT;
  }
  if (store.getState().parametersWidgets.ParameterLookup) {
    country_Calling_Code = store.getState().parametersWidgets.ParameterLookup
      .COUNTRY_DIALING_CODE;
    country_Code = store.getState().parametersWidgets.ParameterLookup
      .COUNTRY_CODE;
    mobileLength = store.getState().parametersWidgets.ParameterLookup
      .MOBILE_LENGTH;
    mobileLength = Number(mobileLength);
    email_regex = store.getState().parametersWidgets.ParameterLookup
      .EMAIL_REGEX;
    billId_length = store.getState().parametersWidgets.ParameterLookup
      .BILLID_LENGTH;
    billId_length = Number(billId_length);
  }
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.quaternary.main,
  },
});
// const DialogTitle = withStyles(styles)((props) => {
//   const { children, classes, onClose, ...other } = props;
//   return (
//     <MuiDialogTitle disableTypography className={classes.root} {...other}>
//       <Typography variant="h6">{children}</Typography>
//       {onClose ? (
//         <IconButton
//           aria-label="close"
//           className={classes.closeButton}
//           onClick={onClose}
//         >
//           <CloseIcon />
//         </IconButton>
//       ) : null}
//     </MuiDialogTitle>
//   );
// });

class VerificationDialogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billId: props.billId,
      mobileNumber: (document.cookie.match(new RegExp('(^| )' + 'mobileNumber' + '=([^;]+)')))?.[2],
      emailId: (document.cookie.match(new RegExp('(^| )' + 'emailId' + '=([^;]+)')))?.[2],
      emailError: false,
      mobileError: false,
      openDialog: false,
      error: false,
      msg: "",
      isSubmitLoading: false,
      directRedirection: false,
      countryCode: "+974",
    };

    const rocketContainer = document.querySelector(".rocketchat-container");
    const rocketWidget = document.querySelector(".rocketchat-widget");
    if (rocketContainer && rocketWidget) {
      rocketContainer.style.display = "none";
      rocketWidget.style.display = "none";
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlesubmitClick = this.handlesubmitClick.bind(this);
    this.handleOnChangePhone = this.handleOnChangePhone.bind(this);
  }

  componentDidMount() {
    if(document.getElementById("mobileNumber_Id")){
    document.getElementById("mobileNumber_Id").style.padding = "9px 1vw";
    document.getElementById("mobileNumber_Id").style.borderRadius = "4px";
    document.getElementById("mobileNumber_Id").style.borderColor = "lightgrey";
    document.getElementById("mobileNumber_Id").style.borderWidth = "thin";
    }
    this.emailBlur = this.emailBlur.bind(this);
    if(this.state.mobileNumber){
      const {
        emailId,
        mobileNumber,
      } = this.state;
    }
    if (this.state.billId) {
      const {
        emailId,
        mobileError,
        emailError,
        mobileNumber,
      } = this.state;
      let notGo = "false";          
            if (mobileNumber || emailId) {
              if (mobileNumber) {
                this.setState({
                  error: false,
                }); 
                
                this.setState({
                  mobileError: false,
                });
              }
              if (emailId) {
                this.setState({
                  error: false,
                });

                var emailRegEx = new RegExp(email_regex);
                var test = emailRegEx.test(emailId);
                if (test) {
                  this.setState({ emailError: false });
                } else {
                  notGo = "true";
                  this.setState({ emailError: true });
                }
              }
              // if (notGo !== "true") {
              //   localStorage.setItem("billpay", false);
              //   localStorage.setItem("email",emailId);
              //   localStorage.setItem("mobileNo",mobileNumber)
              // }
            } else {
              this.setState({
                error: true,
                msg: labels.QUICK_PAY_ERROR_MESSAGE,
                isSubmitLoading: false,
              });
            }
    }
  }
  componentDidUpdate() {
    if(document.getElementById("mobileNumber_Id")){
    if (this.state.mobileError === true) {
      document.getElementById("mobileNumber_Id").style.borderColor = "red";
    } else {
      document.getElementById("mobileNumber_Id").style.borderColor =
        "lightgrey";
    }
    }
  }
  handleOnChangePhone(value) {
    if (value) {
      this.setState({
        mobileNumber: value,
      });
      this.setState({
        error: false,
      });
      if (isValidPhoneNumber(value) === true) {
        let phoneNumber = parsePhoneNumber(value);
        if (phoneNumber) {
          let withoutExtMobile = phoneNumber.nationalNumber;

          if (withoutExtMobile) {
            this.setState({
              mobileError: false,
            });
          } else {
            this.setState({
              mobileError: true,
            });
          }
        }
      } else {
        this.setState({
          mobileError: true,
        });
      }
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      error: false,
    });
    if (name === "mobileNumber") {
      const re = /^[0-9\b]+$/;
      if (e.target.value === "" || re.test(e.target.value)) {
        this.setState({
          [name]: value,
        });
      }
    } else if (name === "email") {
      const re = email_regex;
      if (e.target.value === "" || re.test(e.target.value)) {
        this.setState({
          [name]: value,
        });
      }
    } else {
      this.setState({ [name]: value });
    }
  }

  handleClickOpen() {
    this.setState({ openDialog: true });
  }

  handleClose() {
    this.setState({ openDialog: false });
  }

  handlesubmitClick(e) {
    e.preventDefault();
    const {
      emailId,
      mobileError,
      emailError,
      mobileNumber,
    } = this.state;
    
    if (!mobileNumber && !emailId) {
      this.setState({
        error: true,
        msg: labels.QUICK_PAY_ERROR_MESSAGE,
      });
      return;
    }
    let hasError = false;
          if (mobileNumber || emailId) {
            if (mobileNumber) {
              if(this.state.mobileError===true){
                hasError = true;
              }
            }
            if (emailId) {
              this.setState({
                error: false,
              });

              var emailRegEx = new RegExp(email_regex);
              var test = emailRegEx.test(emailId);
              if (test) {
                this.setState({ emailError: false });
              } else {
                hasError = true;
                this.setState({ emailError: true });
              }
            }

            if (!hasError) {
              this.setState({
                isSubmitLoading: true,
                error: false,
              });
            localStorage.setItem("billpay", false);
            const exdate = new Date();
            exdate.setDate(exdate.getDate() + 45);
            const expires = "expires=" + exdate.toUTCString();
            if (emailId !== undefined && emailId !== null && emailId !== "") {
              document.cookie = "emailId=" + emailId + ";" + expires;
              localStorage.setItem("email", emailId);
            } else {
              localStorage.removeItem("email");
            }
 
            if (mobileNumber !== undefined && mobileNumber !== null && mobileNumber !== "") {
              document.cookie = "mobileNumber=" + mobileNumber + ";" + expires;
              localStorage.setItem("mobileNo", mobileNumber);
            } else {
              localStorage.removeItem("mobileNo");
            }
            
            if (this.props.onSubmitSuccess) {
              this.props.onSubmitSuccess();
              this.setState({isSubmitLoading: false})
            }  
          } 
  }
}


  emailBlur() {
    if (store.getState().parametersWidgets.ParameterLookup) {
      if (this.state.emailId) {
        let email = this.state.emailId?.toLowerCase();
        var emailData = store.getState().parametersWidgets.ParameterLookup
          .EMAIL_REGEX;
        var emailRegEx = new RegExp(emailData);
        var test = emailRegEx.test(email);
        if (test) {
          this.setState({ emailError: false });
        } else {
          this.setState({ emailError: true });
        }
      } 
    }
  }
  updateState = (object) => {
    this.setState({ ...object })
  }

  render() {
    let {mobileNumber, emailId } = this.state;
    let quaternaryColorText = `margin-top-40 ${this.props.baseStyle.quaternaryColor}`;
    let billIdInUrl = new URLSearchParams(window.location.search).get("bill-id");

    const {
      mobileError,
      emailError,
      error,
      msg,
      isSubmitLoading
    } = this.state;
    const { open, handleClose } = this.props;

    return (
      <React.Fragment>
        <Dialog open={open} onClose={handleClose} maxWidth="sm">
        {/* Dialog Title */}
        <DialogTitle disableTypography>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h6" color="primary">
                <b>{labels.QUICK_PAY_ACKNOWLEDGEMENT_TITLE}</b>
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        {/* Dialog Content */}
        <DialogContent>
          <Grid container >
            <Grid item xs={12} md={8}>
              <Typography
                align="left"
                className={this.state.mobileError ? this.props.baseStyle.errorColor : null}
              >
                {labels.SIGNUP_REGISTERED_CELLNUMBER}
              </Typography>
              <PhoneInput
                variant="outlined"
                fullWidth
                flags={flags}
                id="mobileNumber_Id"
                name="mobileNumber"
                value={mobileNumber}
                autoComplete="off"
                placeholder={labels.SIGNUP_CELLNUMBER_PLACEHOLDER}
                international
                countryCallingCodeEditable={false}
                defaultCountry="QA"
                onChange={this.handleOnChangePhone}
                limitMaxLength={true}
              />
              <Typography variant="caption" color="error" className="marginleftError">
                {this.state.mobileError ? labels.SIGNUP_CELLNUMBER_NOT_VALID : null}
              </Typography>
            </Grid>

            <Grid item xs={12} md={8}>
              <Typography
                align="left"
                className={this.state.emailError ? this.props.baseStyle.errorColor : null}
              >
                {labels.SIGNUP_REGISTERED_EMAIL}
              </Typography>
              <OutlinedTextFiled
                fullWidth
                variant="outlined"
                id="emailId_id"
                name="emailId"
                value={emailId?.toLocaleLowerCase()}
                onChange={this.handleChange}
                onBlur={this.emailBlur}
                autoComplete="off"
                placeholder={labels.QUICK_PAY_EMAIL_PLACEHOLDER}
                error={this.state.emailError}
                helperText={this.state.emailError ? labels.ERROR_EMAIL_VALIDATION : null}
              />
            </Grid>
            <br />
             {this.state.error && (
              <Alert severity="error" className="margin-right-30 margin-top-10">
                {this.state.msg}
              </Alert>
            )}
          </Grid>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions>
          <Grid       container
      justify="center"
      alignItems="center"
      direction="row">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={!this.state.isSubmitLoading ? this.handlesubmitClick : null}
            disabled={this.state.isSubmitLoading}
            className={
              this.state.isSubmitLoading
                ? this.props.authStyle.loadingCursor
                : null
            }
          >
            {labels.BUTTON_SUBMIT}
            &nbsp;
            {this.state.isSubmitLoading && (
              <CircularProgress
                size={20}
                color="inherit"
                className={this.props.baseStyle.whiteColor}
              />
            )}
          </Button>
          </Grid>
        </DialogActions>

      </Dialog>
      </React.Fragment>
    );
  }
}


export default VerificationDialogue;
